@file:OptIn(InternalResourceApi::class)

package dentalcrm.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/dentalcrm.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_322_251_845)
internal val Res.string.services_total_label: StringResource by lazy {
      StringResource("string:services_total_label", "services_total_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11395, 104),
      ))
    }

@delegate:ResourceContentHash(1_727_030_726)
internal val Res.string.snackbar_appointment_created: StringResource by lazy {
      StringResource("string:snackbar_appointment_created", "snackbar_appointment_created", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11533, 100),
      ))
    }

@delegate:ResourceContentHash(1_558_236_116)
internal val Res.string.snackbar_appointment_deleted: StringResource by lazy {
      StringResource("string:snackbar_appointment_deleted", "snackbar_appointment_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11634, 72),
      ))
    }

@delegate:ResourceContentHash(196_532_081)
internal val Res.string.snackbar_appointment_updated: StringResource by lazy {
      StringResource("string:snackbar_appointment_updated", "snackbar_appointment_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11707, 96),
      ))
    }

@delegate:ResourceContentHash(1_428_885_521)
internal val Res.string.snackbar_diagnosis_added: StringResource by lazy {
      StringResource("string:snackbar_diagnosis_added", "snackbar_diagnosis_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11804, 76),
      ))
    }

@delegate:ResourceContentHash(-1_432_264_244)
internal val Res.string.snackbar_diagnosis_deleted: StringResource by lazy {
      StringResource("string:snackbar_diagnosis_deleted", "snackbar_diagnosis_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11881, 70),
      ))
    }

@delegate:ResourceContentHash(879_259_023)
internal val Res.string.snackbar_diagnosis_updated: StringResource by lazy {
      StringResource("string:snackbar_diagnosis_updated", "snackbar_diagnosis_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11952, 78),
      ))
    }

@delegate:ResourceContentHash(-528_322_813)
internal val Res.string.snackbar_employee_added: StringResource by lazy {
      StringResource("string:snackbar_employee_added", "snackbar_employee_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12031, 79),
      ))
    }

@delegate:ResourceContentHash(-1_107_622_188)
internal val Res.string.snackbar_employee_deleted: StringResource by lazy {
      StringResource("string:snackbar_employee_deleted", "snackbar_employee_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12111, 77),
      ))
    }

@delegate:ResourceContentHash(1_585_163_123)
internal val Res.string.snackbar_employee_updated: StringResource by lazy {
      StringResource("string:snackbar_employee_updated", "snackbar_employee_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12189, 105),
      ))
    }

@delegate:ResourceContentHash(-1_956_340_159)
internal val Res.string.snackbar_patient_added: StringResource by lazy {
      StringResource("string:snackbar_patient_added", "snackbar_patient_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12295, 74),
      ))
    }

@delegate:ResourceContentHash(-1_148_002_974)
internal val Res.string.snackbar_patient_deleted: StringResource by lazy {
      StringResource("string:snackbar_patient_deleted", "snackbar_patient_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12370, 92),
      ))
    }

@delegate:ResourceContentHash(-761_966_550)
internal val Res.string.snackbar_patient_updated: StringResource by lazy {
      StringResource("string:snackbar_patient_updated", "snackbar_patient_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12463, 96),
      ))
    }

@delegate:ResourceContentHash(692_209_984)
internal val Res.string.snackbar_position_added: StringResource by lazy {
      StringResource("string:snackbar_position_added", "snackbar_position_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12560, 99),
      ))
    }

@delegate:ResourceContentHash(-305_442_959)
internal val Res.string.snackbar_position_deleted: StringResource by lazy {
      StringResource("string:snackbar_position_deleted", "snackbar_position_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12660, 77),
      ))
    }

@delegate:ResourceContentHash(-906_768_087)
internal val Res.string.snackbar_position_updated: StringResource by lazy {
      StringResource("string:snackbar_position_updated", "snackbar_position_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12738, 101),
      ))
    }

@delegate:ResourceContentHash(1_170_090_998)
internal val Res.string.snackbar_quick_reply_added: StringResource by lazy {
      StringResource("string:snackbar_quick_reply_added", "snackbar_quick_reply_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12840, 90),
      ))
    }

@delegate:ResourceContentHash(363_077_669)
internal val Res.string.snackbar_quick_reply_deleted: StringResource by lazy {
      StringResource("string:snackbar_quick_reply_deleted", "snackbar_quick_reply_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12931, 88),
      ))
    }

@delegate:ResourceContentHash(-1_992_683_425)
internal val Res.string.snackbar_quick_reply_updated: StringResource by lazy {
      StringResource("string:snackbar_quick_reply_updated", "snackbar_quick_reply_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13020, 92),
      ))
    }

@delegate:ResourceContentHash(-301_570_662)
internal val Res.string.snackbar_service_added: StringResource by lazy {
      StringResource("string:snackbar_service_added", "snackbar_service_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13113, 74),
      ))
    }

@delegate:ResourceContentHash(977_072_581)
internal val Res.string.snackbar_service_category_added: StringResource by lazy {
      StringResource("string:snackbar_service_category_added", "snackbar_service_category_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13188, 107),
      ))
    }

@delegate:ResourceContentHash(-209_173_253)
internal val Res.string.snackbar_service_category_deleted: StringResource by lazy {
      StringResource("string:snackbar_service_category_deleted", "snackbar_service_category_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13296, 105),
      ))
    }

@delegate:ResourceContentHash(-621_905_490)
internal val Res.string.snackbar_service_category_updated: StringResource by lazy {
      StringResource("string:snackbar_service_category_updated", "snackbar_service_category_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13402, 109),
      ))
    }

@delegate:ResourceContentHash(984_495_347)
internal val Res.string.snackbar_service_deleted: StringResource by lazy {
      StringResource("string:snackbar_service_deleted", "snackbar_service_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13512, 68),
      ))
    }

@delegate:ResourceContentHash(-1_919_659_617)
internal val Res.string.snackbar_service_updated: StringResource by lazy {
      StringResource("string:snackbar_service_updated", "snackbar_service_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13581, 92),
      ))
    }

@delegate:ResourceContentHash(-1_514_443_533)
internal val Res.string.snackbar_treatment_added: StringResource by lazy {
      StringResource("string:snackbar_treatment_added", "snackbar_treatment_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13674, 96),
      ))
    }

@delegate:ResourceContentHash(1_773_889_442)
internal val Res.string.snackbar_treatment_deleted: StringResource by lazy {
      StringResource("string:snackbar_treatment_deleted", "snackbar_treatment_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13771, 94),
      ))
    }

@delegate:ResourceContentHash(-1_089_858_512)
internal val Res.string.snackbar_treatment_edited: StringResource by lazy {
      StringResource("string:snackbar_treatment_edited", "snackbar_treatment_edited", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13866, 97),
      ))
    }

@delegate:ResourceContentHash(-2_078_001_552)
internal val Res.string.snackbar_treatment_updated: StringResource by lazy {
      StringResource("string:snackbar_treatment_updated", "snackbar_treatment_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13964, 122),
      ))
    }

@delegate:ResourceContentHash(-1_707_349_824)
internal val Res.string.stop: StringResource by lazy {
      StringResource("string:stop", "stop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14087, 20),
      ))
    }

@delegate:ResourceContentHash(531_619_086)
internal val Res.string.surname: StringResource by lazy {
      StringResource("string:surname", "surname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14185, 35),
      ))
    }

@delegate:ResourceContentHash(-1_721_677_395)
internal val Res.string.surname_required: StringResource by lazy {
      StringResource("string:surname_required", "surname_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14108, 76),
      ))
    }

@delegate:ResourceContentHash(288_922_914)
internal val Res.string.swipe_complete: StringResource by lazy {
      StringResource("string:swipe_complete", "swipe_complete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14221, 42),
      ))
    }

@delegate:ResourceContentHash(-1_971_714_740)
internal val Res.string.swipe_left_or_right: StringResource by lazy {
      StringResource("string:swipe_left_or_right", "swipe_left_or_right", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14264, 67),
      ))
    }

@delegate:ResourceContentHash(1_261_024_011)
internal val Res.string.tab_all: StringResource by lazy {
      StringResource("string:tab_all", "tab_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14332, 23),
      ))
    }

@delegate:ResourceContentHash(-1_660_551_597)
internal val Res.string.tab_appointment: StringResource by lazy {
      StringResource("string:tab_appointment", "tab_appointment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14356, 39),
      ))
    }

@delegate:ResourceContentHash(286_649_519)
internal val Res.string.tab_services: StringResource by lazy {
      StringResource("string:tab_services", "tab_services", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14396, 36),
      ))
    }

@delegate:ResourceContentHash(-1_797_451_586)
internal val Res.string.tab_treatment: StringResource by lazy {
      StringResource("string:tab_treatment", "tab_treatment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14433, 41),
      ))
    }

@delegate:ResourceContentHash(1_518_104_985)
internal val Res.string.teeth_label: StringResource by lazy {
      StringResource("string:teeth_label", "teeth_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14475, 31),
      ))
    }

@delegate:ResourceContentHash(1_226_263_154)
internal val Res.string.theme: StringResource by lazy {
      StringResource("string:theme", "theme", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14507, 21),
      ))
    }

@delegate:ResourceContentHash(-1_806_086_169)
internal val Res.string.title: StringResource by lazy {
      StringResource("string:title", "title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14578, 45),
      ))
    }

@delegate:ResourceContentHash(923_061_347)
internal val Res.string.title_append: StringResource by lazy {
      StringResource("string:title_append", "title_append", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14529, 48),
      ))
    }

@delegate:ResourceContentHash(-411_464_562)
internal val Res.string.to_edit: StringResource by lazy {
      StringResource("string:to_edit", "to_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14624, 55),
      ))
    }

@delegate:ResourceContentHash(1_169_460_255)
internal val Res.string.today: StringResource by lazy {
      StringResource("string:today", "today", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14680, 33),
      ))
    }

@delegate:ResourceContentHash(1_484_035_811)
internal val Res.string.total_label: StringResource by lazy {
      StringResource("string:total_label", "total_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14714, 31),
      ))
    }

@delegate:ResourceContentHash(1_779_835_335)
internal val Res.string.treatment_form: StringResource by lazy {
      StringResource("string:treatment_form", "treatment_form", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14746, 58),
      ))
    }

@delegate:ResourceContentHash(1_648_966_310)
internal val Res.string.treatment_list_header: StringResource by lazy {
      StringResource("string:treatment_list_header", "treatment_list_header", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14805, 73),
      ))
    }

@delegate:ResourceContentHash(1_347_674_591)
internal val Res.string.unknown_error_message: StringResource by lazy {
      StringResource("string:unknown_error_message", "unknown_error_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14879, 153),
      ))
    }

@delegate:ResourceContentHash(-1_270_437_942)
internal val Res.string.unknown_error_title: StringResource by lazy {
      StringResource("string:unknown_error_title", "unknown_error_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15033, 75),
      ))
    }

@delegate:ResourceContentHash(-1_227_755_671)
internal val Res.string.update: StringResource by lazy {
      StringResource("string:update", "update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15109, 38),
      ))
    }

@delegate:ResourceContentHash(1_032_712_521)
internal val Res.string.visited: StringResource by lazy {
      StringResource("string:visited", "visited", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15186, 31),
      ))
    }

@delegate:ResourceContentHash(1_033_367_923)
internal val Res.string.visited_short: StringResource by lazy {
      StringResource("string:visited_short", "visited_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15148, 37),
      ))
    }

@delegate:ResourceContentHash(159_135_853)
internal val Res.string.warehouse: StringResource by lazy {
      StringResource("string:warehouse", "warehouse", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15218, 33),
      ))
    }

@delegate:ResourceContentHash(430_781_341)
internal val Res.string.week_day_five_short: StringResource by lazy {
      StringResource("string:week_day_five_short", "week_day_five_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15252, 35),
      ))
    }

@delegate:ResourceContentHash(-1_402_078_969)
internal val Res.string.week_day_four_short: StringResource by lazy {
      StringResource("string:week_day_four_short", "week_day_four_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15288, 35),
      ))
    }

@delegate:ResourceContentHash(430_283_543)
internal val Res.string.week_day_one_short: StringResource by lazy {
      StringResource("string:week_day_one_short", "week_day_one_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15324, 34),
      ))
    }

@delegate:ResourceContentHash(1_261_005_578)
internal val Res.string.week_day_seven_short: StringResource by lazy {
      StringResource("string:week_day_seven_short", "week_day_seven_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15359, 36),
      ))
    }

@delegate:ResourceContentHash(2_033_426_626)
internal val Res.string.week_day_six_short: StringResource by lazy {
      StringResource("string:week_day_six_short", "week_day_six_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15396, 34),
      ))
    }

@delegate:ResourceContentHash(2_033_977_279)
internal val Res.string.week_day_three_short: StringResource by lazy {
      StringResource("string:week_day_three_short", "week_day_three_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15431, 36),
      ))
    }

@delegate:ResourceContentHash(1_261_026_720)
internal val Res.string.week_day_two_short: StringResource by lazy {
      StringResource("string:week_day_two_short", "week_day_two_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15468, 34),
      ))
    }

@delegate:ResourceContentHash(-262_710_312)
internal val Res.string.work_place: StringResource by lazy {
      StringResource("string:work_place", "work_place", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15503, 50),
      ))
    }

@delegate:ResourceContentHash(1_610_527_344)
internal val Res.string.work_position: StringResource by lazy {
      StringResource("string:work_position", "work_position", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15554, 45),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("services_total_label", Res.string.services_total_label)
  map.put("snackbar_appointment_created", Res.string.snackbar_appointment_created)
  map.put("snackbar_appointment_deleted", Res.string.snackbar_appointment_deleted)
  map.put("snackbar_appointment_updated", Res.string.snackbar_appointment_updated)
  map.put("snackbar_diagnosis_added", Res.string.snackbar_diagnosis_added)
  map.put("snackbar_diagnosis_deleted", Res.string.snackbar_diagnosis_deleted)
  map.put("snackbar_diagnosis_updated", Res.string.snackbar_diagnosis_updated)
  map.put("snackbar_employee_added", Res.string.snackbar_employee_added)
  map.put("snackbar_employee_deleted", Res.string.snackbar_employee_deleted)
  map.put("snackbar_employee_updated", Res.string.snackbar_employee_updated)
  map.put("snackbar_patient_added", Res.string.snackbar_patient_added)
  map.put("snackbar_patient_deleted", Res.string.snackbar_patient_deleted)
  map.put("snackbar_patient_updated", Res.string.snackbar_patient_updated)
  map.put("snackbar_position_added", Res.string.snackbar_position_added)
  map.put("snackbar_position_deleted", Res.string.snackbar_position_deleted)
  map.put("snackbar_position_updated", Res.string.snackbar_position_updated)
  map.put("snackbar_quick_reply_added", Res.string.snackbar_quick_reply_added)
  map.put("snackbar_quick_reply_deleted", Res.string.snackbar_quick_reply_deleted)
  map.put("snackbar_quick_reply_updated", Res.string.snackbar_quick_reply_updated)
  map.put("snackbar_service_added", Res.string.snackbar_service_added)
  map.put("snackbar_service_category_added", Res.string.snackbar_service_category_added)
  map.put("snackbar_service_category_deleted", Res.string.snackbar_service_category_deleted)
  map.put("snackbar_service_category_updated", Res.string.snackbar_service_category_updated)
  map.put("snackbar_service_deleted", Res.string.snackbar_service_deleted)
  map.put("snackbar_service_updated", Res.string.snackbar_service_updated)
  map.put("snackbar_treatment_added", Res.string.snackbar_treatment_added)
  map.put("snackbar_treatment_deleted", Res.string.snackbar_treatment_deleted)
  map.put("snackbar_treatment_edited", Res.string.snackbar_treatment_edited)
  map.put("snackbar_treatment_updated", Res.string.snackbar_treatment_updated)
  map.put("stop", Res.string.stop)
  map.put("surname", Res.string.surname)
  map.put("surname_required", Res.string.surname_required)
  map.put("swipe_complete", Res.string.swipe_complete)
  map.put("swipe_left_or_right", Res.string.swipe_left_or_right)
  map.put("tab_all", Res.string.tab_all)
  map.put("tab_appointment", Res.string.tab_appointment)
  map.put("tab_services", Res.string.tab_services)
  map.put("tab_treatment", Res.string.tab_treatment)
  map.put("teeth_label", Res.string.teeth_label)
  map.put("theme", Res.string.theme)
  map.put("title", Res.string.title)
  map.put("title_append", Res.string.title_append)
  map.put("to_edit", Res.string.to_edit)
  map.put("today", Res.string.today)
  map.put("total_label", Res.string.total_label)
  map.put("treatment_form", Res.string.treatment_form)
  map.put("treatment_list_header", Res.string.treatment_list_header)
  map.put("unknown_error_message", Res.string.unknown_error_message)
  map.put("unknown_error_title", Res.string.unknown_error_title)
  map.put("update", Res.string.update)
  map.put("visited", Res.string.visited)
  map.put("visited_short", Res.string.visited_short)
  map.put("warehouse", Res.string.warehouse)
  map.put("week_day_five_short", Res.string.week_day_five_short)
  map.put("week_day_four_short", Res.string.week_day_four_short)
  map.put("week_day_one_short", Res.string.week_day_one_short)
  map.put("week_day_seven_short", Res.string.week_day_seven_short)
  map.put("week_day_six_short", Res.string.week_day_six_short)
  map.put("week_day_three_short", Res.string.week_day_three_short)
  map.put("week_day_two_short", Res.string.week_day_two_short)
  map.put("work_place", Res.string.work_place)
  map.put("work_position", Res.string.work_position)
}
